export enum BREAKPOINT {
  DOCS_SIDEBARS = 1500,
  IPAD = 1100,
  PHONE = 800
}

export const IPAD_MEDIA = BREAKPOINT.IPAD;
export const PHONE_MEDIA = BREAKPOINT.PHONE;

export const PAGE_PADDING = 20;
export const DESKTOP_HEADER_PADDING = 80;
export const HEADER_GAP = 12;

export const PAGE_LAYOUT_GAP = 24;
export const DOCS_RAIL_STICKY_TOP = PAGE_LAYOUT_GAP;
export const DOCS_RAIL_BOTTOM_GAP = PAGE_LAYOUT_GAP;

export enum Z_INDEX {
  MENU_SUB_ITEMS = -1,

  SECTION_CONTENT = 1,

  HEADER = 2,
  DESKTOP_HEADER_THEME_ICON = 2,
  MOBILE_HAMBURGER_ICON = 2,

  DESKTOP_DROPDOWN = 3,

  IMAGE_VIEWER = 4,

  STATIC_HEADER = 10
}
